<template>
    <div class="assess-page">
        <div class="public-banner bg-cover">
            <div class="absolute center text-center color-white">
                <h1>产品评测</h1>
                <p class="English">Product Evaluating</p>
            </div>
        </div>
        <div class="container">
            <ul class="type-list">
                <li v-for="(item,index) in typeList" :key="index" class="vertical-middle select-point" :class="{active:item.videoTypeId == askData.videoTypeId}" @click="changeType(item)">
                    {{item.videoTypeName}}
                </li>
            </ul>
            <div class="assess-list">
                <newsItem v-for="(item,index) in listData" :key="index" :item = "item" class="item" @click.native="goDetail(item)"></newsItem>
            </div>
            <div class="pages-wrap">
                <!-- <span class="item select-point btn prev" :class="{disable:askData.pageNumber == 1}" @click="pageSlide('prev')"></span> -->
                <span v-for="(item,index) in pageData.pages" :key="index" class="item select-point" :class="{active:item == askData.pageNumber}" @click="changePage(item)">{{item}}</span>
                <!-- <span class="item select-point btn next" :class="{disable:askData.pageNumber == pageData.pages}" @click="pageSlide('next')"></span> -->
            </div>
        </div>
    </div>
</template>

<script>
	import Vue from 'vue'
    import { CONFIG,network } from '@assets/js/apis';
    import newsItem from '@components/newsItem';
    export default {
		data() {
			return {
                askData:{
                    pageNumber:1,
                    pageSize:15,
                    videoTypeId:0,
                    orderBy:1
                },
                pageData:{
                    pages:0
                },
                typeList:[],  
                listData:[],
			}
        },
        components: {
            newsItem,
		},
        created(){
            network(CONFIG.videoTypes).then(res => {
               this.typeList = res.details.list;
            });
            this.getData();
        },
        mounted: function() {
        },
        methods:{
            initData(){
                this.askData.pageNumber = 1;
                this.getData();
            },
            getData(){
                network(CONFIG.videosByType,this.askData).then(res => {
                    let listData = [];
                    res.data.map(item => {
                        listData.push({
                            id:item.videoId,
                            image:item.background,
                            title:item.title,
                            time:this.formatTime(item.datetime),
                            type:'video'
                        })
                    });
                    this.listData = listData;
                    this.pageData = res.page;
                });
            },
            changeType(item){
                if(this.askData.videoTypeId == item.videoTypeId) return
                this.askData.videoTypeId = item.videoTypeId;
                this.initData();
            },
            changePage(item){
                if(this.askData.pageNumber == item) return
                this.askData.pageNumber = item;
                this.getData();
            },
            goDetail(item){
               this.$router.push("/assessDetail?id="+item.id)
            },
            pageSlide(type){
                let pageNumber = this.askData.pageNumber;
                if((type == 'prev' && pageNumber == 1) || (type == 'next' && pageNumber == this.pageData.pages)) return
                pageNumber = type == 'prev' ? pageNumber - 1 : pageNumber + 1;
                this.askData.pageNumber = pageNumber;
                this.getData();
            }
        }
    }
</script>

<style lang="scss">
    .assess-page {
        min-height: 1000px;
        .public-banner{
            background-image:url('https://resource.tanwuapp.com/Fr9mkuPq6dq4B6eRGGIhWgoafmos') ;
        }
        .assess-list{
            .item{
                margin-bottom: 40px;
                .image{
                    padding-bottom: 56.28%;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/content/children/assess.vue